module.exports = {"member":"Membre","collaborator":"Collaborateur","moderator":"Modérateur","admin":"Admin"};